import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const ChatIcon: React.FC<Props> = ({ color = theme.colors.text }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6654 7.70983C14.6654 11.232 11.6802 14.0876 7.9987 14.0876C7.56583 14.0882 7.13416 14.0482 6.70896 13.9684C6.40292 13.9108 6.24988 13.8821 6.14305 13.8984C6.03621 13.9148 5.88482 13.9952 5.58202 14.1563C4.72546 14.6118 3.72666 14.7727 2.7661 14.594C3.13119 14.145 3.38053 13.6062 3.49055 13.0286C3.55722 12.6752 3.39203 12.332 3.14462 12.0808C2.02092 10.9397 1.33203 9.4021 1.33203 7.70983C1.33203 4.18774 4.31722 1.33203 7.9987 1.33203C11.6802 1.33203 14.6654 4.18774 14.6654 7.70983Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M7.9957 8H8.0017M10.6594 8H10.6654M5.33203 8H5.33801"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
